module.exports = __webpack_public_path__ + "static/media/sg.682e09da.svg";